import {
  DELETE_USER_FAILURE,
  DELETE_USER_REQUEST,
  DELETE_USER_SUCCESS,
  FETCH_CURRENT_USER_FAILURE,
  FETCH_CURRENT_USER_REQUEST,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_USER_FAILURE,
  FETCH_USER_REQUEST,
  FETCH_USER_SUCCESS,
  FETCH_USERS_FAILURE,
  FETCH_USERS_REQUEST,
  FETCH_USERS_SUCCESS,
  FETCH_USER_GROUP_FAILURE,
  FETCH_USER_GROUP_GROUP_PERM_OBJECT_FAILURE,
  FETCH_USER_GROUP_GROUP_PERM_OBJECT_SUCCESS,
  FETCH_USER_GROUP_PERM_OBJECT_REQUEST,
  FETCH_USER_GROUP_REQUEST,
  FETCH_USER_GROUP_SUCCESS,
  SAVE_AVATAR_FAILURE,
  SAVE_AVATAR_REQUEST,
  SAVE_AVATAR_SUCCESS,
  SAVE_USER_FAILURE,
  SAVE_USER_REQUEST,
  SAVE_USER_SUCCESS,
  SAVE_PERSONAL_DETAILS_FAILURE,
  SAVE_PERSONAL_DETAILS_REQUEST,
  SAVE_PERSONAL_DETAILS_SUCCESS,
  SAVE_SECURITY_DETAILS_FAILURE,
  SAVE_SECURITY_DETAILS_REQUEST,
  SAVE_SECURITY_DETAILS_SUCCESS,
  SAVE_USER_GROUP_FAILURE,
  SAVE_USER_GROUP_REQUEST,
  SAVE_USER_GROUP_SUCCESS,
  DELETE_USER_GROUP_REQUEST,
  DELETE_USER_GROUP_SUCCESS,
  DELETE_USER_GROUP_FAILURE,
} from '../reducers/types';
import {
  getUserGroupsDetailedService,
  getUserGroupsService,
  saveAvatarService,
  savePersonalDetailsService,
  saveSecurityDetailsService,
  saveUserGroupService,
  deleteUsersService,
  getUserByIdService,
  getUsersService,
  saveUserService,
  deleteUserGroupsService,
  getCurrentUser,
} from '../services/UserService';
import { itemsPaginationParams } from '../pages/items/Constants';

export const getUserGroupsAction = (value = '') => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCH_USER_GROUP_REQUEST,
      });
      const response = await dispatch(getUserGroupsService(value));
      if (response.status === 200) {
        dispatch({
          type: FETCH_USER_GROUP_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: FETCH_USER_GROUP_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: FETCH_USER_GROUP_FAILURE,
      });
    }
  };
};

// TODO: to be removed
export const getUserGroupsDetailedAction = () => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCH_USER_GROUP_PERM_OBJECT_REQUEST,
      });
      const response = await dispatch(getUserGroupsDetailedService());
      if (response.status === 200) {
        dispatch({
          type: FETCH_USER_GROUP_GROUP_PERM_OBJECT_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: FETCH_USER_GROUP_GROUP_PERM_OBJECT_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: FETCH_USER_GROUP_GROUP_PERM_OBJECT_FAILURE,
      });
    }
  };
};

export const getCurrentUserAction = () => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCH_CURRENT_USER_REQUEST,
      });
      const response = await dispatch(getCurrentUser());
      if (response.status === 200) {
        dispatch({
          type: FETCH_CURRENT_USER_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: FETCH_CURRENT_USER_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: FETCH_CURRENT_USER_FAILURE,
      });
    }
  };
};

export const savePersonalDetailsAction = (data, id = 0) => {
  return async dispatch => {
    try {
      dispatch({
        type: SAVE_PERSONAL_DETAILS_REQUEST,
      });
      const response = await dispatch(savePersonalDetailsService(data, id));
      if (response.status === 200) {
        dispatch({
          type: SAVE_PERSONAL_DETAILS_SUCCESS,
          payload: response.data,
        });
        dispatch(getCurrentUserAction());
      } else {
        dispatch({
          type: SAVE_PERSONAL_DETAILS_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: SAVE_PERSONAL_DETAILS_FAILURE,
      });
    }
  };
};

export const saveSecurityDetailsAction = (data, id = 0) => {
  return async dispatch => {
    try {
      dispatch({
        type: SAVE_SECURITY_DETAILS_REQUEST,
      });
      const response = await dispatch(saveSecurityDetailsService(data, id));
      if (response.status === 200) {
        dispatch({
          type: SAVE_SECURITY_DETAILS_SUCCESS,
          payload: response.data,
        });
        dispatch(getCurrentUserAction());
      } else {
        dispatch({
          type: SAVE_SECURITY_DETAILS_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: SAVE_SECURITY_DETAILS_FAILURE,
      });
    }
  };
};

export const saveAvatarAction = (data, id = 0) => {
  return async dispatch => {
    try {
      dispatch({
        type: SAVE_AVATAR_REQUEST,
      });
      const response = await dispatch(saveAvatarService(data, id));
      if (response.status === 200) {
        dispatch({
          type: SAVE_AVATAR_SUCCESS,
          payload: response.data,
        });
        dispatch(getCurrentUserAction());
      } else {
        dispatch({
          type: SAVE_AVATAR_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: SAVE_AVATAR_FAILURE,
      });
    }
  };
};

export const saveUserGroupAction = (dataToSend, id = 0) => {
  return async dispatch => {
    try {
      dispatch({
        type: SAVE_USER_GROUP_REQUEST,
      });
      const response = await dispatch(saveUserGroupService(dataToSend, id));
      if (response.status === 200) {
        dispatch({
          type: SAVE_USER_GROUP_SUCCESS,
          payload: response.data,
        });
        dispatch(getUserGroupsAction());
        dispatch(getCurrentUserAction());
      } else {
        dispatch({
          type: SAVE_USER_GROUP_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: SAVE_USER_GROUP_FAILURE,
      });
    }
  };
};

export const deleteUserGroupsAction = array => {
  return async dispatch => {
    try {
      dispatch({
        type: DELETE_USER_GROUP_REQUEST,
      });
      const response = await dispatch(deleteUserGroupsService(array));
      if (response.status === 200) {
        dispatch({
          type: DELETE_USER_GROUP_SUCCESS,
        });
        dispatch(getUserGroupsAction());
      } else {
        dispatch({
          type: DELETE_USER_GROUP_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: DELETE_USER_GROUP_FAILURE,
      });
    }
  };
};
export const getUsersAction = (params = null) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCH_USERS_REQUEST,
      });
      const response = await dispatch(getUsersService(params));
      if (response.status === 200) {
        dispatch({
          type: FETCH_USERS_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: FETCH_USERS_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: FETCH_USERS_FAILURE,
      });
    }
  };
};

export const getUserByIdAction = id => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCH_USER_REQUEST,
      });
      const response = await dispatch(getUserByIdService(id));
      if (response.status === 200) {
        dispatch({
          type: FETCH_USER_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: FETCH_USER_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: FETCH_USER_FAILURE,
      });
    }
  };
};

export const saveUserAction = (data, id = 0) => {
  return async dispatch => {
    try {
      dispatch({
        type: SAVE_USER_REQUEST,
      });
      const response = await dispatch(saveUserService(data, id));
      if (response.status === 200) {
        dispatch({
          type: SAVE_USER_SUCCESS,
          payload: response.data,
        });
        dispatch(getUsersAction({ ...itemsPaginationParams }));
      } else {
        dispatch({
          type: SAVE_USER_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: SAVE_USER_FAILURE,
      });
    }
  };
};

export const deleteUsersAction = array => {
  return async dispatch => {
    try {
      dispatch({
        type: DELETE_USER_REQUEST,
      });
      const response = await dispatch(deleteUsersService(array));
      if (response.status === 200) {
        dispatch({
          type: DELETE_USER_SUCCESS,
        });
        dispatch(getUsersAction({ ...itemsPaginationParams }));
      } else {
        dispatch({
          type: DELETE_USER_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: DELETE_USER_FAILURE,
      });
    }
  };
};
